<script setup>
/* global defineEmits, defineExpose */
import { ref, getCurrentInstance } from "vue";
import { ElMessage } from "element-plus";

const { appContext } = getCurrentInstance();

// 定义抛出的事件（用于刷新父组件列表）
const emit = defineEmits(["refresh"]);

// 弹窗可见性控制
const refundDialogVisible = ref(false);

// 表单数据
const refundForm = ref({
    merchant_id: null,
    restrict_next_day_refund: 0,
});

// 暴露给父组件的打开方法
const open = (row) => {
    refundForm.value.merchant_id = row.id;
    // 如果当前行数据中带有该状态字段则回显，否则默认设为 0（关闭状态）
    refundForm.value.restrict_next_day_refund = row.restrict_next_day_refund ?? 0;
    refundDialogVisible.value = true;
};

// 提交配置
const submitRefundConfig = () => {
    appContext.config.globalProperties.$api.merchants
        .restrictNextDayRefund(refundForm.value)
        .then((res) => {
            if (res.status == 200 || (res.data && res.data.status === "success")) {
                ElMessage.success("隔日退款权限设置成功");
                refundDialogVisible.value = false;
                // 通知父组件刷新列表
                emit("refresh");
            } else {
                ElMessage.error("设置失败，请稍后重试");
            }
        })
        .catch((err) => {
            console.error(err);
            ElMessage.error("请求异常");
        });
};

// 暴露方法
defineExpose({
    open,
});
</script>

<template>
    <el-dialog v-model="refundDialogVisible" title="隔日退款权限设置" width="400px" destroy-on-close>
        <el-form :model="refundForm" label-width="140px">
            <el-form-item label="是否限制隔天退款:">
                <el-switch v-model="refundForm.restrict_next_day_refund" :active-value="1" :inactive-value="0"
                    active-text="是" inactive-text="否" />
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="refundDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitRefundConfig">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>